import { DateFilterType, DatePeriod, FilterTypes, } from './types/prism';
export const required = (type, description) => ({
    type,
    optional: false,
    description,
});
export const optional = (type, description, defaultValue) => ({
    type,
    optional: true,
    description,
    default: defaultValue,
});
export const arrayOf = (elementType) => ({
    type: 'array',
    optional: false,
    arrayOf: elementType,
});
export const optionalArrayOf = (elementType) => ({
    type: 'array',
    optional: true,
    arrayOf: elementType,
});
export const requiredArrayOf = (elementType) => ({
    type: 'array',
    optional: false,
    arrayOf: elementType,
});
export const objectOf = (properties) => ({
    type: 'object',
    properties,
    optional: false,
});
export const optionalObjectOf = (properties) => ({
    type: 'object',
    properties,
    optional: true,
});
export const enumOf = (values, description) => ({
    type: 'string',
    optional: false,
    enum: values,
    description,
});
export const optionalEnumOf = (values, description) => ({
    type: 'string',
    optional: true,
    enum: values,
    description,
});
export const unionOf = (types, description) => ({
    unionOf: types,
    optional: false,
    description,
});
export const optionalUnionOf = (types, description) => ({
    unionOf: types,
    optional: true,
    description,
});
export const oneOf = (contracts, description) => ({
    oneOf: contracts,
    optional: false,
    description,
});
export const optionalOneOf = (contracts, description) => ({
    oneOf: contracts,
    optional: true,
    description,
});
export const voidParam = (description) => ({
    type: 'void',
    optional: true,
    description,
});
export const FILTER_OPERATORS = [
    FilterTypes.Eq,
    FilterTypes.Ne,
    FilterTypes.Lt,
    FilterTypes.Le,
    FilterTypes.Gt,
    FilterTypes.Ge,
    FilterTypes.Contains,
    FilterTypes.BeginsWith,
    FilterTypes.EndsWith,
    FilterTypes.In,
    FilterTypes.NotIn,
    FilterTypes.Bw,
    FilterTypes.BwInc,
    FilterTypes.BwIncMax,
    FilterTypes.BwIncMin,
    FilterTypes.Like,
];
export const DATE_FILTER_TYPES = [
    DateFilterType.ExactDate,
    DateFilterType.ExactDateRange,
    DateFilterType.ExactDateTime,
    DateFilterType.ExactTime,
    DateFilterType.LastNPeriod,
    DateFilterType.LastPeriod,
    DateFilterType.NextNPeriod,
    DateFilterType.NextPeriod,
    DateFilterType.NPeriodAgo,
    DateFilterType.PeriodToDate,
    DateFilterType.ThisPeriod,
    DateFilterType.Today,
    DateFilterType.Tomorrow,
];
export const DATE_PERIODS = [
    DatePeriod.Day,
    DatePeriod.Week,
    DatePeriod.Month,
    DatePeriod.Quarter,
    DatePeriod.Year,
];
export var HostEventContexts;
(function (HostEventContexts) {
    HostEventContexts["ANSWER"] = "answer";
    HostEventContexts["LIVEBOARD"] = "liveboard";
    HostEventContexts["SEARCH"] = "search-answer";
    HostEventContexts["SPOTTER"] = "spotter";
    HostEventContexts["SAGE"] = "sage";
    HostEventContexts["OTHER"] = "other";
})(HostEventContexts || (HostEventContexts = {}));
//# sourceMappingURL=host-event-schema.js.map